/** 题目选项API */
import type { Api } from '@/typings/api';
import { post } from '../../request';
const prefix = '/st/stSurveyOption';
/**
 * 分页查询题目选项
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.St.StSurveyOption> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询题目选项列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.St.StSurveyOption> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个题目选项
 *
 * @param id 题目选项ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.St.StSurveyOption> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存题目选项
 *
 * @param params 题目选项信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新题目选项信息
 *
 * @param params 题目选项信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除题目选项
 *
 * @param id 题目选项ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除题目选项
 *
 * @param ids 题目选项ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete
};
